import React from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import axios from 'axios';
import { PageFooter } from './footer';

class CompanyListItem extends React.Component {
    render() {
        return (
            <div
                className="Company"
                onClick={() => window.open('https://fundersclub.com' + this.props.company.url)}
            >
                <div className="Company-wrapper">
                    <p href="#" className="Company-title">
                       <strong>{this.props.company.company_name}</strong>&nbsp;&nbsp;{this.props.company.public_blurb}
                    </p>
                    <div className="Company-arrow">
                        <img src={process.env.PUBLIC_URL + '/arrow.svg'} alt=""/>
                    </div>
                </div>
            </div>
        );
    };
};


class CompanyList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            isLoaded: false,
            companies: [
                {
                    'slug': 'coinbase1',
                    'name': 'Coinbase',
                    'description': 'Bitcoin made simple.',
                    'url': 'https://fundersclub.com/companies/coinbase',
                },
                {
                    'slug': 'coinbase2',
                    'name': 'Coinbase',
                    'description': 'Bitcoin made simple. Bitcoin made simple. Bitcoin made simple. Bitcoin made simple.',
                    'url': 'https://fundersclub.com/companies/coinbase',
                },
                {
                    'slug': 'coinbase3',
                    'name': 'Coinbase',
                    'description': 'Bitcoin made simple.',
                    'url': 'https://fundersclub.com/companies/coinbase',
                },
                {
                    'slug': 'coinbase4',
                    'name': 'Coinbase',
                    'description': 'Bitcoin made simple.',
                    'url': 'https://fundersclub.com/companies/coinbase',
                },
            ]
        };
    }

    componentDidMount() {
        axios.get('https://fundersclub.com/portfolio/?format=json').then((response) => {
            this.setState({
                companies: response.data.companies,
                error: false,
                isLoaded: true,
            });
        });
    }

    reloadPage() {
        window.location.reload()
    }

    render() {
        const { error, isLoaded, companies } = this.state;
        if (error) {
            return (
                <div className="HalfContainer">
                    <p className="Type-body">
                        Could not load companies. <p className="Type-link" href="#" onClick={this.reloadPage}>Refresh</p>
                    </p>
                </div>
            )
        } else if (!isLoaded) {
            return (
                <div className="HalfContainer u-center">
                    <div className="Loader"></div>
                </div>
            )
        } else {
            return (
                <div className="HalfContainer">
                    {companies.map(company => (
                        <CompanyListItem company={company} key={company.url} />
                    ))}
                </div>
            );
        }
    }
}

class Companies extends React.Component {
    componentDidMount() {
        AOS.init({
            duration: 400,
            anchor: '#app',
            placement: 'top-center',
            easing: 'ease-in',
            delay: 800,
        });
    }

    render() {
        return (
            <div className="MainContainer">
                <div className="HalfContainer u-mb-4">
                    <h1
                        data-aos="fade-up"
                        data-aos-delay="200"
                        className="Type-h1"
                    >
                        The Revolutionaries.
                    </h1>
                    <div data-aos="fade">
                        <p className="Type-body u-mb-4">
                            We’ve partnered with over 275 top startups across FCVC & FundersClub, representing the top 2% or less of startups we’ve reviewed. We use our scale to benefit our founders. Few VC investors have been a part of as many startup journeys as we have, and we draw from the shared insights and best practices we’ve learned from this unique perspective to help our founders. We also encourage and facilitate our founders to help each other, which has led to an active founder and alumni founder community.
                        </p>
                        <CompanyList />
                    </div>
                </div>
                <PageFooter/>
            </div>
        );
    };
};

export default Companies;



// WEBPACK FOOTER //
// ./src/components/companies.js